/**
 * Values to map to Traffic Source Detail Page
 * key - the key that is used to pull and save data to GraphQl
 * label - Friendly label for the user
 */
const trafficSourceFields = [
    {
        title: null,
        arr: [
            {
                key: 'affiliateName',
                label: "Affiliate Name",
                type: 'autoComplete',
                val: "allAffiliate",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
        ]
    },
    {
        title: null,
        arr: [
            {
                key: 'name',
                label: "Traffic Source",
                type: 'text',
                val: "allTrafficSource",
                required: true
            },
        ]
    },
    {
        title: 'PAY CONFIG',
        perRow: 2,
        arr: [
            {
                key: 'minimumPrice',
                label: 'Min Price',
                type: 'text',
                inputType: 'number',
                val: "",
                required: false
            },
            {
                key: 'timeout',
                label: 'Timeout',
                type: 'text',
                inputType: 'number',
                val: "",
                required: false
            },
            {
                key: 'maximumPrice',
                label: 'Max Price (Legacy)',
                type: 'text',
                inputType: 'number',
                val: "",
                required: false
            },
            {
                key: 'priceRejectMins.mins',
                label: 'Price Reject Mins',
                type: 'text',
                inputType: 'text',
                val: "",
                required: false
            },
            {
                key: 'payoutStrategy',
                label: 'Payout Strategy',
                type: 'payoutStrategyInput',
                val: "allAffiliatePayoutStrategy",
                required: true
            },
            {
                key: 'priceRejectMins.config.noPennies',
                label: 'Price Reject Config (No Pennies)',
                type: 'switch',
                val: true,
                required: false
            },
            {
                key: 'priceRejectMins.config.checkNextTier',
                label: 'Price Reject Config (Check Next Tier)',
                type: 'switch',
                val: false,
                required: false
            },
            {
                key: 'priceRejectMins.config.returnAnyBid',
                label: 'Price Reject Config (Return Any Bid)',
                type: 'switch',
                val: false,
                required: false
            }
        ]
    },
    {
        title: 'OPTIONS',
        perRow: 3,
        arr: [
            {
                key: 'internal',
                label: 'Internal',
                type: 'switch',
                val: false,
                required: true
            },
            {
                key: 'aggregatorOnly',
                label: 'Agg Only',
                type: 'switch',
                val: false,
                required: true
            },
            {
                key: 'includeS3InSource',
                label: 'Include S3 In Source Id',
                type: 'switch',
                val: false,
                required: true
            },
            {
                key: 'isTest',
                label: 'Is Test',
                type: 'switch',
                val: false,
                required: true
            },
            {
                key: 'proxyToOlp',
                label: 'Proxy To Olp',
                type: 'switch',
                val: false,
                required: true
            },
            {
                key: 'isListManageable',
                label: 'List Manageable',
                type: 'switch',
                val: false,
                required: true
            },
            {
                key: 'splitTest',
                label: 'Split Test',
                type: 'switch',
                val: false,
                required: true
            },
            {
                key: 'multiTierSubmit',
                label: 'Multi-Tier Submit',
                type: 'switch',
                val: false,
                required: false
            },
            {
                key: 'pinpoint',
                label: 'Pinpoint',
                type: 'switch',
                val: false,
                required: true
            },
            {
                key: 'multiOffer',
                label: 'Multi-Offer',
                type: 'switch',
                val: false,
                required: false
            },
            {
                key: 'exclusive',
                label: 'Exclusive',
                type: 'switch',
                val: false,
                required: false
            },
            {
                key: 'multiConversion',
                label: 'Multi-Conversion',
                type: 'switch',
                val: false,
                required: false
            },
            {
                key: 'trafficSourceSelectionStrategy',
                label: 'Traffic Source Selection Strategy',
                type: 'autoComplete',
                val: "allTrafficSourceSelectionStrategy",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            }
        ]
    },
    {
        title: 'SOURCE INFO',
        perRow: 2,
        arr: [
            {
                key: 'origin',
                label: 'Origin',
                type: 'autoComplete',
                val: "allTrafficOrigin",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
            {
                key: 'medium',
                label: 'Medium',
                type: 'autoComplete',
                val: "allTrafficMedium",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
            {
                key: 'channel',
                label: 'Channel',
                type: 'autoComplete',
                val: "allTrafficChannels",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
            {
                key: 'rootPingTree',
                label: 'Ping Tree',
                type: 'autoComplete',
                val: 'allPingTree',
                displayKey: 'id',
                returnKey: 'id',
                required: true
            },
            {
                key: 'sourceUrl',
                label: "Source Url",
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'offerUrl',
                label: "Offer Url",
                type: 'text',
                val: "",
                required: false
            },
        ]
    },
    {
        title: 'EVERFLOW',
        perRow: 2,
        arr: [
            {
                key: 'everflowAffiliateHash',
                label: 'Everflow Affiliate Hash (Read Only)',
                type: 'text',
                inputType: 'string',
                val: "",
                required: false,
                disabled: true
            },
        ]
    },
    {
        title: 'LEGACY',
        perRow: 3,
        arr: [
            {
                key: 'legacyZoneId',
                label: 'Zone Id',
                type: 'text',
                inputType: 'number',
                val: "",
                required: false
            },
            {
                key: 'legacyPromoId',
                label: 'Promo Id',
                type: 'text',
                inputType: 'number',
                val: "",
                required: false,
            },
            {
                key: 'legacyOfferId',
                label: 'Offer Id',
                type: 'text',
                inputType: 'number',
                val: "",
                required: false
            },
        ]
    },
    {
        title: 'FEEDS',
        perRow: 2,
        arr: [
            {
                key: 'soldFeed',
                label: 'Sold Feed',
                type: 'autoComplete',
                val: "allFeeds",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
            {
                key: 'unsoldFeed',
                label: 'Unsold Feed',
                type: 'autoComplete',
                val: "allFeeds",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
        ]
    },
    {
        title: 'OFFER',
        perRow: 1,
        display: false,
        arr: [
            {
                label: 'Offer Id',
                type: 'trafficSourceOfferInput',
                key: "offerId",
                required: true
            }
        ]
    }
];

const offerFields = {
    title: 'OFFER',
    perRow: 3,
    arr: [
        {
            type: 'id',
            key: "id",
            required: false,
            label: "ID"
        },
        {
            type: 'text',
            key: "offerName",
            required: false,
            label: "Offer Name"
        },
        {
            type: 'text',
            key: "advertiserId",
            required: false,
            label: "Advertiser Id"
        },
    ]
}

const eventPayoutFields = [
    {
        key: 'event',
        type: 'autoComplete',
        val: 'allRevenueEvents',
        label: 'Revenue Event',
        returnKey: 'name',
        displayKey: 'name',
        required: true,
        fullWidth: false,
    },
    {
        key: 'payoutStrategy',
        type: 'autoComplete',
        val: 'allEventPayoutStrategyTypes',
        label: 'Payout Strategy',
        returnKey: 'name',
        displayKey: 'name',
        required: true,
        fullWidth: false,
    },
    {
        key: 'payoutType',
        type: 'autoComplete',
        val: 'allPayoutTypes',
        label: 'Payout Type',
        returnKey: 'name',
        displayKey: 'name',
        required: true,
        fullWidth: false,
    },
    {
        key: 'payout',
        label: 'Payout',
        type: 'text',
        inputType: 'number',
        val: "",
        required: false
    },
    {
        key: 'fieldId',
        type: 'autoComplete',
        val: 'allField',
        label: 'Frontend Field',
        returnKey: 'name',
        displayKey: 'name',
        required: false,
        fullWidth: false,
    },
    {
        key: 'dataPackageType',
        type: 'autoComplete',
        val: 'allDataPackageTypes',
        label: 'Frontend Data Package Type',
        returnKey: 'name',
        displayKey: 'name',
        required: false,
        fullWidth: false,
    },
    {
        key: 'companyId',
        label: "Company Name",
        type: 'autoComplete',
        val: "allCompanies",
        returnKey: 'name',
        displayKey: 'name',
        required: true,
        useVal: true,
    },
    {
        key: 'billed',
        label: 'Billed',
        type: 'text',
        inputType: 'number',
        val: "",
        required: true
    },
    {
        key: 'revShare',
        label: 'Rev Share',
        type: 'text',
        inputType: 'number',
        val: "",
        required: false
    }
];

export { trafficSourceFields, eventPayoutFields, offerFields };
